import { stow, createLocation$ } from '@zambezi/caballo-vivo'
import {
  displayPayments$,
  displayPaymentDetails$,
  displaySOPayments$,
  displaySOPaymentDetails$,
  displayFundsChecks$,
  displayFundsChecksForTpp$,
  displayFundsCheckDetails$,
  displayAccesses$,
  displayAccessesForTpp$,
  displayAccessDetails$,
  displayBiometrics$,
  displayMortgages$,
  displayVrp$,
  displayVrpForTpp$,
  displayVrpDetails$,
  displaySweeping$,
  displaySweepingForTpp$,
  displaySweepingDetails$,
  displayPayYou$,
  displayPayMe$,
  displayPayMeLinkHistory$,
  displayPayYouLinkHistory$,
  displayPayMeReusableLinkHistory$,
} from './intents'

const location$ = createLocation$({
  '/:rootPath/payments': (_, search) => displayPayments$.next({ search }),
  '/:rootPath/payments/:paymentId': ({ paymentId }) =>
    displayPaymentDetails$.next(paymentId),

  '/:rootPath/recurring-payments/standing-orders': () =>
    displaySOPayments$.next(),
  '/:rootPath/recurring-payments/standing-orders/:paymentId': ({ paymentId }) =>
    displaySOPaymentDetails$.next(paymentId),

  '/:rootPath/recurring-payments/vrp/tpps': () => displayVrp$.next(),
  '/:rootPath/recurring-payments/vrp/tpps/:clientId/payments': ({ clientId }) =>
    displayVrpForTpp$.next(clientId),
  '/:rootPath/recurring-payments/vrp/tpps/:clientId/payments/:consentId': ({
    clientId,
    consentId,
  }) => displayVrpDetails$.next({ clientId, consentId }),

  '/:rootPath/recurring-payments/sweeping/tpps': () => displaySweeping$.next(),
  '/:rootPath/recurring-payments/sweeping/tpps/:clientId/payments': ({
    clientId,
  }) => displaySweepingForTpp$.next(clientId),
  '/:rootPath/recurring-payments/sweeping/tpps/:clientId/payments/:consentId':
    ({ clientId, consentId }) =>
      displaySweepingDetails$.next({ clientId, consentId }),

  '/:rootPath/funds-checks/tpps': () => displayFundsChecks$.next(),
  '/:rootPath/funds-checks/tpps/:clientId/funds-checks': ({ clientId }) =>
    displayFundsChecksForTpp$.next(clientId),
  '/:rootPath/funds-checks/tpps/:clientId/funds-checks/:fundsCheckId': ({
    clientId,
    fundsCheckId,
  }) => displayFundsCheckDetails$.next({ clientId, fundsCheckId }),

  '/:rootPath/access-agreements/tpps': () => displayAccesses$.next(),
  '/:rootPath/access-agreements/tpps/:clientId/agreements': ({ clientId }) =>
    displayAccessesForTpp$.next(clientId),
  '/:rootPath/access-agreements/tpps/:clientId/agreements/:accessId': ({
    clientId,
    accessId,
  }) => displayAccessDetails$.next({ clientId, accessId }),
  '/:rootPath/biometrics': () => displayBiometrics$.next(),
  '/:rootPath/mortgages': () => displayMortgages$.next(),
  '/:rootPath/paymeyou/pay-you': () => displayPayYou$.next(),
  '/:rootPath/paymeyou/pay-me': () => displayPayMe$.next(),
  '/:rootPath/paymeyou/pay-me/:linkId': ({ linkId }) =>
    displayPayMeLinkHistory$.next({ linkId }),
  '/:rootPath/paymeyou/pay-you/:linkId': ({ linkId }) =>
    displayPayYouLinkHistory$.next({ linkId }),
  '/:rootPath/paymeyou/pay-me/reusable-link/:linkId': ({ linkId }) =>
    displayPayMeReusableLinkHistory$.next({ linkId }),
}).pipe(stow('location'))

export default location$
